import React from 'react';

import _Base from './../_Base';
import {Button} from '@components';
import {Props} from './types';

import './index.scss';

const FailedCalling: React.FC<Props> = props => {
  return (
    <_Base
      title="安否確認の送信失敗"
      isModal={props.isModal}
      handleCloseModal={props.handleCloseModal}
      size="sm"
    >
      <div className="a__failed-calling-modal">
        <div className="w__message">
          <div className="b__title-lael">
            選択頂きました手段で連絡可能な人数が0人です。
            <br />
            未回答ユーザ様全員が以下の状態であることが考えられます。
          </div>
          <ul className="reason">
            <li>削除された状態である</li>
            <li>「メール」を選択された場合</li>
            <ul>
              <li>対象ユーザがメール配信エラー状態になっている</li>
            </ul>
            <li>「SMS」、「電話」を選択された場合</li>
            <ul>
              <li>対象ユーザに携帯番号が登録されていない</li>
              <li>対象ユーザの携帯番号の形式が正しくない</li>
            </ul>
          </ul>
        </div>

        <div className="w__modal-buttons">
          <Button.Normal
            text="閉じる"
            onClick={() => props.handleCloseModal(!props.isModal)}
          />
        </div>
      </div>
    </_Base>
  );
};
export default FailedCalling;
